// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widget.pattern-editor {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 3px;
}

.pattern-editor .control-panel {
  flex-direction: row;
  gap: 5px;
}

.pattern-editor .controls {
  height: 38px;
}

.pattern-editor .controls .control-group {
  gap: 5px;
}

.pattern-editor .controls button {
  width: 22px;
  height: 22px;
  padding: 0;
}

.chrome.record {
  border-color: red !important;
}

.hscroll {
  background: black;
  flex: 1 1 auto;
  display: flex;
  position: relative;
}

.hscroll .pattern {
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
  width: 100%;
}

.hscroll .pattern .patterndata {
  border: 1px solid white;
  flex: 1 1 auto;
  overflow-x: scroll;
  overflow-y: hidden;
  position: relative;
}

.hscroll .pattern .patterndata::-webkit-scrollbar {
  -webkit-appearance: none;
}

.hscroll .pattern .patterndata::-webkit-scrollbar-thumb {
  border-radius: 2px;
  border: 1px solid #93C3E9; /* should match background, can't be transparent */
  background-color: #A0D4FD;
}

.hscroll .pattern .patterndata::-webkit-scrollbar-track {
  background-color: #333;
  border-radius: 8px;
}

.hscroll .pattern .patterndata::-webkit-scrollbar:horizontal {
  height: 11px;
}

.hscroll .pattern .timeline {
  border: 1px solid black;
}

.hscroll .track-headers {
  position: absolute;
  display: flex;
  flex-direction: column;
  margin-top: 5px;
}

.track-names {
  display: flex;
  flex-direction: row;
}

.track-names .track-name {
  color: white;
  flex: 1 1 auto;
  text-align: center;
  font-family: monospace;
}

.track-controls {
  display: flex;
  flex-direction: row;
  height: 28px;
}

.track-controls .track-control {
  color: white;
  flex: 1 1 auto;
  text-align: center;
  font-family: monospace;
  display: flex;
  height: 28px;
  padding: 0 3px;
}

.track-control .panel {
  flex: 1;
  background: #444;
  border-radius: 3px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2px;
}

.track-control .panel .control-group {
  gap: 5px;
  align-items: center;
}

.track-control .panel button {
  font-size: 12px;
  height: 18px;
  width: 18px;
}

.hscroll .track-names input.inline-editor {
  font-size: 1em;
  font-family: monospace;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1 auto;
  text-align: center;
  color: white;
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/pattern_editor/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB,EAAE,kDAAkD;EAC7E,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ","sourcesContent":[".widget.pattern-editor {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  gap: 3px;\n}\n\n.pattern-editor .control-panel {\n  flex-direction: row;\n  gap: 5px;\n}\n\n.pattern-editor .controls {\n  height: 38px;\n}\n\n.pattern-editor .controls .control-group {\n  gap: 5px;\n}\n\n.pattern-editor .controls button {\n  width: 22px;\n  height: 22px;\n  padding: 0;\n}\n\n.chrome.record {\n  border-color: red !important;\n}\n\n.hscroll {\n  background: black;\n  flex: 1 1 auto;\n  display: flex;\n  position: relative;\n}\n\n.hscroll .pattern {\n  display: flex;\n  flex-direction: row;\n  flex: 1 1 auto;\n  width: 100%;\n}\n\n.hscroll .pattern .patterndata {\n  border: 1px solid white;\n  flex: 1 1 auto;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  position: relative;\n}\n\n.hscroll .pattern .patterndata::-webkit-scrollbar {\n  -webkit-appearance: none;\n}\n\n.hscroll .pattern .patterndata::-webkit-scrollbar-thumb {\n  border-radius: 2px;\n  border: 1px solid #93C3E9; /* should match background, can't be transparent */\n  background-color: #A0D4FD;\n}\n\n.hscroll .pattern .patterndata::-webkit-scrollbar-track {\n  background-color: #333;\n  border-radius: 8px;\n}\n\n.hscroll .pattern .patterndata::-webkit-scrollbar:horizontal {\n  height: 11px;\n}\n\n.hscroll .pattern .timeline {\n  border: 1px solid black;\n}\n\n.hscroll .track-headers {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  margin-top: 5px;\n}\n\n.track-names {\n  display: flex;\n  flex-direction: row;\n}\n\n.track-names .track-name {\n  color: white;\n  flex: 1 1 auto;\n  text-align: center;\n  font-family: monospace;\n}\n\n.track-controls {\n  display: flex;\n  flex-direction: row;\n  height: 28px;\n}\n\n.track-controls .track-control {\n  color: white;\n  flex: 1 1 auto;\n  text-align: center;\n  font-family: monospace;\n  display: flex;\n  height: 28px;\n  padding: 0 3px;\n}\n\n.track-control .panel {\n  flex: 1;\n  background: #444;\n  border-radius: 3px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 2px;\n}\n\n.track-control .panel .control-group {\n  gap: 5px;\n  align-items: center;\n}\n\n.track-control .panel button {\n  font-size: 12px;\n  height: 18px;\n  width: 18px;\n}\n\n.hscroll .track-names input.inline-editor {\n  font-size: 1em;\n  font-family: monospace;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1 1 auto;\n  text-align: center;\n  color: white;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
